import { render, staticRenderFns } from "./BalanceVanCollapseContent.vue?vue&type=template&id=19b937f4&scoped=true"
import script from "./BalanceVanCollapseContent.vue?vue&type=script&lang=js"
export * from "./BalanceVanCollapseContent.vue?vue&type=script&lang=js"
import style0 from "./BalanceVanCollapseContent.vue?vue&type=style&index=0&id=19b937f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b937f4",
  null
  
)

export default component.exports